<template>
  <div class="customerInfo boxs">
    <vue-scroll :ops="ops" ref="vs">
    <div class="tit">客户信息</div>

    <div class="flex-row">
      <!-- 图片 -->
      <ul class="imgArea flex-col boxs">
        <li>
          <img :src="'data:image/jpeg;base64,' + certInfo.card_pic_front" alt="" v-if="certInfo.card_pic_front">
          <img src="@/assets/images/order/idCard1.png" alt="" v-else>
        </li>
        <li>
          <img :src="'data:image/jpeg;base64,' + certInfo.card_pic_front" alt="" v-if="certInfo.card_pic_back">
          <img src="@/assets/images/order/idCard2.png" alt="" v-else>
        </li>
        <li>
          <img :src="'data:image/jpeg;base64,' + certInfo.holding_pic" alt="" v-if="certInfo.holding_pic">
          <img src="@/assets/images/order/headImg.png" alt="" v-else>
        </li>
      </ul>

      <!-- 信息 -->
      <ul class="orderlist">
        <li>
          <span class="listTit">客户名称：</span>
          <span class="listVal">{{certInfo.name || '-'}}</span>
        </li>
        <li>
          <span class="listTit">性别：</span>
          <span class="listVal">{{certInfo.gender ? (certInfo.gender=='1' ? '男' : '女') : '-'}}</span>
        </li>
        <li>
          <span class="listTit">民族：</span>
          <span class="listVal">{{certInfo.nation || '-'}}</span>
        </li>
        <li>
          <span class="listTit">出生日期：</span>
          <span class="listVal">{{certInfo.birth_day || '-'}}</span>
        </li>
        <li>
          <span class="listTit">证件地址：</span>
          <span class="listVal" :title="certInfo.cert_address">{{certInfo.cert_address || '-'}}</span>
        </li>
        <li>
          <span class="listTit">证件号码：</span>
          <span class="listVal">{{certInfo.cert_number || '-'}}</span>
        </li>
        <li>
          <span class="listTit">签发机关：</span>
          <span class="listVal">{{certInfo.cert_org || '-'}}</span>
        </li>
        <li>
          <span class="listTit">有效期开始：</span>
          <span class="listVal">{{certInfo.eff_date || '-'}}</span>
        </li>
        <li>
          <span class="listTit">有效期结束：</span>
          <span class="listVal">{{certInfo.exp_date || '-'}}</span>
        </li>
        <li>
          <span class="listTit">联系电话：</span>
          <span class="listVal">{{order_base.contact_phone || '-'}}</span>
        </li>
      </ul>

    </div>

    </vue-scroll>

  </div>
</template>

<script>

  import {getOrderCertReq} from '@/api/Order/NumCardOrder/internetBuyCardOrder.js';

  export default {
    name: "customerInfo",
    props: {
      orderItem: {
        required: true,
        type: Object
      }
    },
    data() {
      return {
        certInfo: {},
        order_base: this.orderItem,
        //ops滚动条配置
        ops: {
            scrollPanel: {
                padding: true
            },
            rail: {
                background: '#fff',
                opacity: 1,
                gutterOfSide: 0,
                size: '8px'
            },
            bar: {
                keepShow: true,
                background: '#ddd',
                size: '5px'
            },
        }
      }
    },
    watch: {
      orderItem(val) {
        this.order_base = val
        getOrderCertReq({id: this.order_base.id})
          .then(res => {
            this.certInfo = res.body;
          })
          .catch(e => console.log(e));
      }
    }
  }
</script>

<style scoped>
  .customerInfo {
    width: 33%;
    min-width: 360px;
    height: 300px;
    background: #fff;
    overflow: hidden;
    /* padding-top: 16px; */
  }

  .customerInfo .tit {
    font-size: 13px;
    font-weight: bold;
    color: #333;
    text-indent: 14px;
    height: 48px;
    line-height: 48px;
  }

  .imgArea {
    width: 82px;
    padding-left: 10px;
  }

  .imgArea li + li {
    margin-top: 10px;
  }

  .imgArea li img {
    width: 72px;
    height: 72px;
  }


  .orderlist {
    width: calc(100% - 82px);
  }
  .orderlist li {
    padding-left: 10px;
    font-size: 12px;
  }

  .orderlist li + li {
    /* margin-top: 5px; */
    margin-top: 7px;
  }

  .orderlist li .listTit {
    display: inline-block;
    color: #7F7F7F;
    margin-right: 8px;
    /* width: 84px; */
    width: 80px;
    text-align: right;
    vertical-align: top;
  }

  .orderlist li .listVal {
    display: inline-block;
    width: 170px;
    color: #2B2727;
    vertical-align: middle;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }


  .orderlist li.marginTop {
    margin-top: 15px;
  }

</style>
